import React from 'react';
import { Users, UserPlus, CreditCard, Settings as SettingsIcon, HelpCircle, ClipboardList } from 'lucide-react';

const Navbar = ({
  currentView,
  setCurrentView,
  user,
  subscription,
  teamStatus,
  mobileMenuOpen,
  setMobileMenuOpen,
  isFeatureAvailable,
  loadClients,
  loadTemplates,
  handleLogout
}) => {
  return (
    <>
      <nav className="navbar">
        <div className="nav-brand" onClick={() => setCurrentView('home')}>
          <img src="/plate-planner-pro-logo.webp" alt="Logo" className="nav-logo-img" />
          <span className="nav-brand-text">Plate Planner Pro</span>
        </div>
        
        <button 
          className="hamburger-btn"
          onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          aria-label="Toggle menu"
        >
          <span className={`hamburger-line ${mobileMenuOpen ? 'open' : ''}`}></span>
          <span className={`hamburger-line ${mobileMenuOpen ? 'open' : ''}`}></span>
          <span className={`hamburger-line ${mobileMenuOpen ? 'open' : ''}`}></span>
        </button>
        
        <div className="nav-links desktop-nav">
          <button className={`nav-link ${currentView === 'clients' || currentView === 'client-detail' ? 'active' : ''}`} onClick={() => { setCurrentView('clients'); loadClients(); }}>Clients</button>
          <button className={`nav-link ${currentView === 'add-client' ? 'active' : ''}`} onClick={() => setCurrentView('add-client')}>Add Client</button>
          {isFeatureAvailable('meal_templates') && !teamStatus?.is_team_member && (
            <button className={`nav-link ${currentView === 'templates' ? 'active' : ''}`} onClick={() => { setCurrentView('templates'); loadTemplates(); }}><ClipboardList size={16} /> Templates</button>
          )}
          {!teamStatus?.is_team_member && (
            <button className={`nav-link ${currentView === 'billing' ? 'active' : ''}`} onClick={() => setCurrentView('billing')}><CreditCard size={16} /> Billing</button>
          )}
          {!teamStatus?.is_team_member && (
            <button className={`nav-link ${currentView === 'settings' ? 'active' : ''}`} onClick={() => setCurrentView('settings')}><SettingsIcon size={16} /> Settings</button>
          )}
          <button className={`nav-link ${currentView === 'help' ? 'active' : ''}`} onClick={() => setCurrentView('help')}><HelpCircle size={16} /> Help</button>
        </div>
        <div className="nav-user desktop-nav">
          <span className="user-name">{user.name}</span>
          {teamStatus?.is_team_member && (
            <span className="team-badge">Team Member</span>
          )}
          {subscription && (
            <span className={`plan-badge plan-${subscription.plan}`}>
              {subscription.plan_status === 'trialing' ? `Trial: ${subscription.trial_days_remaining}d left` : subscription.plan_name}
            </span>
          )}
          <button className="btn-logout" onClick={handleLogout}>Logout</button>
        </div>
      </nav>
      
      {mobileMenuOpen && (
        <div className="mobile-menu-overlay" onClick={() => setMobileMenuOpen(false)}>
          <div className="mobile-menu" onClick={(e) => e.stopPropagation()}>
            <div className="mobile-menu-header">
              <span className="user-name">{user.name}</span>
              {subscription && (
                <span className={`plan-badge plan-${subscription.plan}`}>
                  {subscription.plan_status === 'trialing' ? `Trial: ${subscription.trial_days_remaining}d left` : subscription.plan_name}
                </span>
              )}
            </div>
            <div className="mobile-menu-links">
              <button className={`mobile-nav-link ${currentView === 'clients' || currentView === 'client-detail' ? 'active' : ''}`} onClick={() => { setCurrentView('clients'); loadClients(); setMobileMenuOpen(false); }}>
                <Users size={18} /> Clients
              </button>
              <button className={`mobile-nav-link ${currentView === 'add-client' ? 'active' : ''}`} onClick={() => { setCurrentView('add-client'); setMobileMenuOpen(false); }}>
                <UserPlus size={18} /> Add Client
              </button>
              {isFeatureAvailable('meal_templates') && !teamStatus?.is_team_member && (
                <button className={`mobile-nav-link ${currentView === 'templates' ? 'active' : ''}`} onClick={() => { setCurrentView('templates'); loadTemplates(); setMobileMenuOpen(false); }}>
                  <ClipboardList size={18} /> Templates
                </button>
              )}
              {!teamStatus?.is_team_member && (
                <button className={`mobile-nav-link ${currentView === 'billing' ? 'active' : ''}`} onClick={() => { setCurrentView('billing'); setMobileMenuOpen(false); }}>
                  <CreditCard size={18} /> Billing
                </button>
              )}
              {!teamStatus?.is_team_member && (
                <button className={`mobile-nav-link ${currentView === 'settings' ? 'active' : ''}`} onClick={() => { setCurrentView('settings'); setMobileMenuOpen(false); }}>
                  <SettingsIcon size={18} /> Settings
                </button>
              )}
              <button className={`mobile-nav-link ${currentView === 'help' ? 'active' : ''}`} onClick={() => { setCurrentView('help'); setMobileMenuOpen(false); }}>
                <HelpCircle size={18} /> Help
              </button>
            </div>
            <div className="mobile-menu-footer">
              <button className="btn-logout-mobile" onClick={() => { handleLogout(); setMobileMenuOpen(false); }}>
                Logout
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Navbar;
